import Loading from "./components/Loading";
import Loadable from "react-loadable";

// mobile banner
export const MobileBanner = Loadable({
  loader: () => import("./components/MobileBanner"),
  loading: Loading
});

// video loop
export const VideoLoop = Loadable({
  loader: () => import("./components/VideoLoop"),
  loading: Loading
});

// buy now links
export const BuyNowLinks = Loadable({
  loader: () => import("./components/BuyNowLinks"),
  loading: Loading
});

// social links
export const SocialLinks = Loadable({
  loader: () => import("./components/SocialLinks"),
  loading: Loading
});

// bundle trailer
export const BundleTrailer = Loadable({
  loader: () => import("./components/BundleTrailer"),
  loading: Loading
});

// KF2 trailer
export const KF2Trailer = Loadable({
  loader: () => import("./components/KF2Trailer"),
  loading: Loading
});

// Incursion trailer
export const KFIncursionTrailer = Loadable({
  loader: () => import("./components/KFIncursionTrailer"),
  loading: Loading
});

// carousel
export const Carousel = Loadable({
  loader: () => import("./components/Carousel"),
  loading: Loading
});

// footer
export const Footer = Loadable({
  loader: () => import("./components/Footer"),
  loading: Loading
});
